import React from 'react';
import { Landmark } from 'lucide-react';

// N°, statut et date de signature du mandat SEPA Stripe sur la carte du membre
export function MandatSepaLigne({ mandat, docId }) {
  if (!mandat) return null;
  const actif = mandat.statut === 'active';
  const date = mandat.signe_le ? new Date(mandat.signe_le).toLocaleDateString('fr-FR') : null;
  return (
    <div className={`mt-2 flex flex-wrap items-center gap-1.5 rounded-lg border px-2 py-1.5 text-[11px] ${actif ? 'border-emerald-200 bg-emerald-50 text-emerald-800' : 'border-rose-200 bg-rose-50 text-rose-700'}`}
      data-testid={`mandat-sepa-${docId}`}>
      <Landmark className="h-3.5 w-3.5 shrink-0" />
      <span className="font-bold">Mandat SEPA Stripe {actif ? 'actif' : 'révoqué'}</span>
      <span className="font-mono break-all" data-testid={`mandat-sepa-numero-${docId}`}>· n° {mandat.numero}</span>
      {date && <span>· signé le {date}</span>}
    </div>
  );
}
